import NewsLetter from "./NewsLetter";

export { NewsLetter };
